import React from "react";
import { Fade, Bounce } from "react-reveal";
import Lottie from "react-lottie";
import HeroLottie from "../lotties/hero.json";
import { Link } from "react-router-dom";

export default function Home() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: HeroLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Fade>
      <div className="flex flex-col-reverse items-center flex-grow px-6 mt-24 mb-2 sm:px-8 md:px-12 lg:px-20 xl:px-24 lg:flex-row">
        <Bounce left cascade>
          <div className="flex flex-col flex-1">
            <div className="max-sm:pt-4 max-lg:pt-8">
              <div className="pb-1 text-2xl font-black sm:text-5xl md:text-6xl lg:text-4xl xl:text-5xl 2xl:text-6xl sm:pb-3 2xl:pb-4">
                Hello 👋
              </div>

              <div className="pb-1 text-2xl font-black sm:text-5xl md:text-6xl lg:text-4xl xl:text-5xl 2xl:text-6xl sm:pb-3 2xl:pb-4">
                I am Ichsan 🙋
              </div>
              <div className="pb-1 text-2xl font-black sm:text-5xl md:text-6xl lg:text-4xl xl:text-5xl 2xl:text-6xl sm:pb-3 2xl:pb-4">
                Fullstack Developer 👨‍💻
              </div>
              <div className="pb-2 text-justify sm:pb-3 2xl:pb-4">
                I am Fullstack Developer 🙋 with 1 year experience as Developer
                👨‍💻. I can use Go, Javascript, Typescript and PHP 💻 and
                currently I live in Depok, West Java 🌆🧑‍💼.
              </div>
            </div>
            <div className="flex flex-col justify-center sm:flex-row lg:justify-start max-sm:space-y-2 sm:space-x-2">
              <a
                href="https://linktr.ee/mesanfaz"
                className="duration-500 bg-mesanfaz-black text-mesanfaz-gray hover:text-black border border-mesanfaz-black hover:bg-mesanfaz-gray rounded-lg text-center max-sm:w-full max-lg:w-1/2 sm:px-5 max-md:py-3 md:py-4 lg:py-2.5 hover:shadow-2xl"
              >
                Explore My Work
              </a>
              <Link
                to={"/about"}
                className="duration-500 hover:text-mesanfaz-gray border border-mesanfaz-black hover:bg-mesanfaz-black rounded-lg text-center max-sm:w-full max-lg:w-1/2 sm:px-5 max-md:py-3 md:py-4 lg:py-2.5 hover:shadow-2xl"
              >
                About Me
              </Link>
            </div>
          </div>
        </Bounce>
        <div className="flex items-center justify-center flex-1">
          <div>
            <Lottie options={defaultOptions} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
